import type { Invitation } from '#/domain/invitation/Invitation'
import type { InvitationRepository } from '#/domain/invitation/InvitationRepository'

export class CreateInvitationsUseCase {
  constructor(private readonly repository: InvitationRepository) {}

  async execute(invitations: Invitation[], organizationId?: string): Promise<void> {
    return this.repository.create(invitations, organizationId)
  }
}
